import {environment} from '../../environments/environment';

export function isStagingEnvironment(webAppBaseUrl = environment.webAppBaseUrl): boolean {
  return new URL(webAppBaseUrl).origin === 'https://staging.invemory.com';
}

export function nativeAuthScheme(webAppBaseUrl = environment.webAppBaseUrl): string {
  return isStagingEnvironment(webAppBaseUrl) ? 'invemory-staging:' : 'storemate:';
}

export function nativeGoogleAuthReady(webAppBaseUrl = environment.webAppBaseUrl, stagingReady = false): boolean {
  return !isStagingEnvironment(webAppBaseUrl) || stagingReady;
}

export function isNativeAuthCallback(url: URL, webAppBaseUrl = environment.webAppBaseUrl): boolean {
  return url.protocol === nativeAuthScheme(webAppBaseUrl)
    && url.hostname === 'auth'
    && !url.port && !url.username && !url.password
    && (url.pathname === '' || url.pathname === '/')
    && !url.search;
}

export function isAllowedNativeQrUrl(url: string, webAppBaseUrl = environment.webAppBaseUrl): boolean {
  if (!isStagingEnvironment(webAppBaseUrl)) return true;
  try {
    const parsed = new URL(url);
    return parsed.origin === new URL(webAppBaseUrl).origin
      && !parsed.username && !parsed.password;
  } catch {
    return false;
  }
}
